import loadergif from "../assets/ISDB Resource Center.gif"
const LoaderTemplate = () => {
    return (
        <div className="loader-template">
            <div className="loader">
             <img src={loadergif} alt="Loader Image"/>

            </div>
        </div>
    )
};
export default LoaderTemplate;
